<template>
  <div class="define-radiance layers" :class="{ desktop: bigEnough }">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content" :class="{ invisible: fsMenu }">

        <div class="top-taller"></div>

        <div class="step2 flex-center fv">
          <img class="diamond" src="./img/step2.svg" />
          <img class="diamond-1440" src="./img/step2-1440.svg" />
          <div class="step2-con">
            {{ T('/define-radiance@step2') }}
          </div>
        </div>

        <div class="title flex-center fv">
          <div class="title-con">
            {{ T('/define-radiance@title') }}
          </div>
        </div>

        <div class="radiance flex-center fv" v-if="delayShow">
          <div class="radiance-frame-1">
            <RCard :frameOnly="true" />
          </div>
          <div class="radiance-frame-2">
            <RCard :frameOnly="true" />
          </div>
          <div class="radiance-con">
            <swiper :options="swiperOption">

              <swiper-slide :key="rcard.number" v-for="rcard in rcards">
                <RCard
                  :name="rcard.name"
                  :number="rcard.number"
                  :image="rcard.image"
                />
              </swiper-slide>

              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              <div class="swiper-button-prev" slot="button-prev">

              </div>
              <div class="swiper-button-next" slot="button-next">

              </div>
            </swiper>

          </div>
        </div>

        <!-- <div class="next" @click="goNext">
          <img class="next-frame" src="./img/next.svg" alt="">
          <div class="next-con">
            {{ T('/define-radiance@next') }}
          </div>
        </div> -->
        <CTA class="cta-btn" :text="T('/define-radiance@next')" @action="goNext" />

        <div class="back" @click="goBack">
          <div class="back-con">
            {{ T('/define-radiance@adjust-photo') }}
          </div>
        </div>


        <div class="bottom-taller"></div>
        <!-- <div class="taller"></div>
        <div class="taller"></div> -->
      </div>
    </div>
    <!-- <FloatMenu v-if="bigEnough" class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu v-if="bigEnough" class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" /> -->
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'
import * as PhotoStore from '@/components/DOM/PhotoStore/PhotoStore.js'

import RCard from './RCard.vue'
import CTA from '@/components/DOM/CTA/CTA.vue'

// import Instruction from './Instruction.vue'

export default {
  components: {
    RCard,
    FloatMenu,
    FullMenu,
    CTA
    // Instruction
  },
  data () {
    function num (n) {
      return n > 9 ? '' + n : '0' + n
    }
    var self = this
    return {
      bigEnough: window.innerWidth >= 767,
      Text,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {},

      currentCardID: '01',
      delayShow: false,

      swiperOption: {
        slidesPerView: window.innerWidth >= 1365 ? 1 : 1,
        spaceBetween: 30,
        loop: true,
        // centeredSlides: true,
        // spaceBetween: 30,
        grabCursor: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true
        // },
        hashNavigation: {
          watchState: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        on: {
          slideChange () {
            self.currentCardID = num(this.realIndex + 1)
            console.log(self.nowCard)
          }
        }
      },
      get nowCard () {
        return self.rcards.find((rc) => { return rc.number === self.currentCardID })
      },
      rcards: [
        {
          name: 'Kindness',
          number: '01',
          image: ''
        },
        {
          name: 'UNCOMPROMISING',
          number: '02',
          image: ''
        },
        {
          name: 'JOURNEY',
          number: '03',
          image: ''
        },
        {
          name: `SELF
CONFIDENCE`,
          number: '04',
          image: ''
        },
        {
          name: 'SHARING',
          number: '05',
          image: ''
        },
        {
          name: 'Radiance is...',
          number: '06',
          image: ''
        }
      ]
    }
  },
  watch: {
    bigEnough (newVal, oldVal) {
      if (newVal !== oldVal) {
        window.location.reload()
      }
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    this.setupScroll()
    window.addEventListener('resize', () => {
      this.setupScroll()

      this.bigEnough = window.innerWidth >= 1440
    })

    if (!PhotoStore.state.imageURL) {
      this.$router.push('/choose-photo')
    }
    if (!PhotoStore.state.originalImageURL) {
      this.$router.push('/choose-photo')
    }

    this.$nextTick(() => {
      this.delayShow = true
    })
  },
  methods: {
    goNext () {
      PhotoStore.state.chosenRadiance = this.nowCard
      this.$router.push('/data-form')
    },
    goBack () {
      this.$router.push('/choose-photo/adjust-photo')
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.long-content{
  height: 100%;
}
.define-radiance{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
}
.top-taller{
  height: 1px;
}
.desktop .top-taller{
  height: 10px;
}
.bottom-taller{
  height: 1px;
}
.flex-center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.fv {
  flex-direction: column;
}

.step2{
  margin-top: 20px;
}
.step2-con{
  margin-top: 5px;
  text-transform: uppercase;
  /* step 2: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 10px;
  /* color: #CEBC9E; */
  color: white;
  letter-spacing: 1.24px;
  text-align: center;
  line-height: 20px;
}

.title{
  margin-top: 5px;
}
.title-con{
  text-transform: uppercase;
  width: 100%;
  max-width: 300px;
  /* Would you like to jo: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 22px;
}

.radiance{
  overflow: hidden;
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.radiance-frame-1{
  position: absolute;
  top: 0px;
  left: calc(-70px);
  opacity: 0.3;
}
.radiance-frame-2{
  position: absolute;
  top: 0px;
  right: calc(-70px);
  opacity: 0.3;
}
.desktop .radiance-frame-1{
  display: none;
}
.desktop .radiance-frame-2{
  display: none;
}

.radiance-con{
  width: 100%;
  height: 284px;
  /* max-width: 310px; */
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.desktop .radiance-con{
  height: 556px;
  width: 600px;
}

.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
  background-image: url('data:image/svg+xml;charset=utf-8,<svg width="13px" height="24px" viewBox="0 0 13 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="05-choose-radiance" transform="translate(-27.000000, -310.000000)" stroke="#CEBC9E"><polyline id="Page-1" points="39.434412 333.245847 28 321.811435 39.434412 310.377023"></polyline></g></g></svg>');
  left: 30px;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  background-image: url('data:image/svg+xml;charset=utf-8,<svg width="13px" height="24px" viewBox="0 0 13 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="05-choose-radiance" transform="translate(-340.000000, -310.000000)" stroke="#CEBC9E"><polyline id="Page-1-Copy-2" transform="translate(346.282794, 321.811435) scale(-1, 1) translate(-346.282794, -321.811435) " points="352 333.245847 340.565588 321.811435 352 310.377023"></polyline></g></g></svg>');
  right: 30px;
}

.next{
  cursor: pointer;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.next-frame{
  position: absolute;
  top: 0px;
  left: calc(50% - 259.2px / 2);
  width: 259.2px;
}
.next-con{
  display: flex;
  justify-content: center;
  align-items: center;

  height: 53.64px;

  text-transform: uppercase;
  /* next copy: */
  border: 0 solid #FFFFFF;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
}

.back{
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-con{
  cursor: pointer;
  display: inline-block;
  border-bottom: #CEBC9E solid 1px;
  /* Adjust photo: */
  /* border: 0 solid #CEBC9E; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 1px;
  text-align: center;
  line-height: 20px;
}

.diamond-1440{
  display: none;
}

@media screen and (min-width: 374px) {
  .radiance{
    margin-top: 30px;
  }
  .radiance-frame-1{
    left: calc(-30px);
    opacity: 0.3;
  }
  .radiance-frame-2{
    right: calc(-30px);
    opacity: 0.3;
  }
  .next{
    margin-top: 25px;
  }
  .next-con{
    height: 62.09px;
  }
  .next-frame{
    left: calc(50% - 300px / 2);
    width: 300px;
  }
}


@media screen and (min-width: 414px) {
  .radiance{
    margin-top: 45px;
  }
  .radiance-frame-1{
    left: calc(-10px);
    opacity: 0.3;
  }
  .radiance-frame-2{
    right: calc(-10px);
    opacity: 0.3;
  }
  .next{
    margin-top: 45px;
  }
  .next-con{
    height: 68.3px;
  }
  .next-frame{
    left: calc(50% - 330px / 2);
    width: 330px;
  }
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .title{
    margin-top: 20px;
  }
  .title-con{
    font-size: 20px;
    letter-spacing: 2.31px;
    line-height: 30px;
    margin-top: -11px;
  }
  .step2-con{
    /* step 1: */
    font-family: CronosPro-LtDisp, PingFang-SC-Regular;
    font-size: 11px;
    color: #FFFFFF;
    letter-spacing: 1.01px;
    text-align: center;
    line-height: 20px;
  }
  .diamond-1440{
    display: block;
  }
  .diamond{
    display: none;
  }
  .next{
    margin-top: 45px;
  }
  .next-con{
    height: 76px;
  }
  .next-frame{
    left: calc(50% - 360px / 2);
    width: 360px;
  }

  .cta-row.cta-btn{
    margin-top: 50px;
    margin-bottom: 0px;
  }
  .back{
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .back-con{
    font-size: 14px;
  }
}

.invisible{
  visibility: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/DefineRadiance/DefineRadiance.vue